import { render, staticRenderFns } from "./DeletedClients.vue?vue&type=template&id=b70628f8&"
import script from "./DeletedClients.vue?vue&type=script&lang=js&"
export * from "./DeletedClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports